import { LOCALE } from "./Locale";

export const routes = [
  {
    name: LOCALE.charts,
    url: "/app/charts",
    icon: "dashboard",
    position: "1",
    hasAccess: ["ROLE_ADMINISTRATION", "ROLE_COMMISSION_USER"],
  },
  {
    name: LOCALE.open_vacancies,
    url: "/app/open-vacancies/",
    icon: "cast-for-education",
    position: "1",
    hasAccess: ["ROLE_TEACHER"],
  },
  {
    name: LOCALE.bureau_grading_dashboard,
    url: "/app/grading/bureau/",
    icon: "cast-for-education",
    position: "1",
    hasAccess: ["ROLE_BUREAU"],
  },
  {
    name: LOCALE.school_grading_dashboard,
    url: "/app/grading/school/",
    icon: "cast-for-education",
    position: "1",
    hasAccess: ["ROLE_SCHOOL_USER"],
  },
  {
    name: LOCALE.educational_center_grading_dashboard,
    url: "/app/grading/educationalCenter/",
    icon: "cast-for-education",
    position: "1",
    hasAccess: ["ROLE_EDUCENTER"],
  },
  {
    name: LOCALE.commission_grading,
    url: "/app/commission-grading/",
    icon: "cast-for-education",
    position: "1",
    hasAccess: ["ROLE_COMMISSION_USER"],
  },
  {
    name: LOCALE.view_applications,
    url: "/app/commission-preview/",
    icon: "cast-for-education",
    position: "1",
    hasAccess: ["ROLE_COMMISSION_USER"],
  },
  {
    name: LOCALE.rank_lists,
    url: "/app/rank-list/",
    icon: "cast-for-education",
    position: "1",
    hasAccess: ["ROLE_COMMISSION_USER", "ROLE_ADMINISTRATION"],
  },
  {
    name: LOCALE.distribution_by_commission,
    url: "/app/vacancy-allotment/",
    icon: "balance",
    position: "1",
    hasAccess: ["ROLE_ADMINISTRATION"],
  },
  {
    name: LOCALE.transfer_applications,
    url: "/app/vacancy-transfer/",
    icon: "move_up",
    position: "1",
    hasAccess: ["ROLE_ADMINISTRATION"],
  },
  {
    name: LOCALE.finishing_applications,
    url: "/app/vacancy-add-data-req/",
    icon: "edit_note",
    position: "1",
    hasAccess: ["ROLE_ADMINISTRATION"],
  },
  {
    name: LOCALE.my_applications,
    url: "/app/my-vacancy-applications/",
    icon: "cast-for-education",
    position: "1",
    hasAccess: ["ROLE_TEACHER"],
  },
  {
    name: LOCALE.administration,
    icon: "settings",
    hasAccess: ["ROLE_ADMINISTRATION"],
    children: [
      {
        name: LOCALE.users,
        url: "/app/admin/users",
        icon: "person",
        position: "2",
        hasAccess: ["ROLE_ADMINISTRATION"],
      },
      {
        name: LOCALE.groups,
        url: "/app/admin/groups",
        icon: "groups",
        position: "2",
        hasAccess: ["ROLE_ADMINISTRATION"],
      },
      {
        name: LOCALE.privileges,
        url: "/app/admin/privileges",
        icon: "report",
        position: "2",
        hasAccess: ["ROLE_ADMINISTRATION"],
      },
      {
        name: LOCALE.settings,
        url: "/app/admin/settings",
        icon: "settings",
        position: "2",
        hasAccess: ["ROLE_ADMINISTRATION"],
      },
      {
        name: LOCALE.audit_log,
        url: "/app/admin/auditLog",
        icon: "track_changes",
        position: "2",
        hasAccess: ["ROLE_ADMINISTRATION"],
      },
      {
        name: LOCALE.mail_log,
        url: "/app/admin/mailLog",
        icon: "all_inbox",
        position: "2",
        hasAccess: ["ROLE_ADMINISTRATION"],
      },
      {
        name: LOCALE.mail_template,
        url: "/app/admin/mailTemplate",
        icon: "square_foot",
        position: "2",
        hasAccess: ["ROLE_ADMINISTRATION"],
      },
      {
        name: LOCALE.formbuilder,
        url: "/app/formBuilder",
        icon: "build",
        position: "2",
        hasAccess: ["ROLE_ADMINISTRATION"],
      },
    ],
  },
  {
    name: LOCALE.configuration,
    icon: "list",
    hasAccess: ["ROLE_ADMINISTRATION"],
    children: [
      {
        name: LOCALE.municipalities,
        url: "/app/configuration/municipalities",
        icon: "apartment",
        position: "2",
        hasAccess: ["ROLE_ADMINISTRATION"],
      },
      {
        name: LOCALE.schools,
        url: "/app/configuration/schools",
        icon: "school",
        position: "2",
        hasAccess: ["ROLE_ADMINISTRATION"],
      },
      {
        name: LOCALE.grading_schema,
        url: "/app/configuration/gradingSchema",
        icon: "grade",
        position: "2",
        hasAccess: ["ROLE_ADMINISTRATION"],
      },
      {
        name: LOCALE.vacancy,
        url: "/app/vacancy",
        icon: "build",
        position: "2",
        hasAccess: ["ROLE_ADMINISTRATION"],
      },
    ],
  },
];
